import type { LayoutChangeEvent } from "@-/com.npmjs.react-native";
import { useState } from "react";

/**
 * `radius`, but never past a capsule once the view has laid out. A Liquid Glass view hands its
 * React Native radii to UIKit's corner configuration unscaled, and a radius over half the short
 * side leaves the glass square instead of round, where UIKit and CSS would clamp it.
 */
export function useCappedCornerRadius(radius: number): {
  borderRadius: number | undefined;
  onLayout: (event: LayoutChangeEvent) => void;
} {
  const [shortSide, setShortSide] = useState<number | null>(null);
  return {
    borderRadius: shortSide === null ? undefined : Math.min(radius, shortSide / 2),
    onLayout: (event) => {
      const { height, width } = event.nativeEvent.layout;
      setShortSide(Math.min(height, width));
    },
  };
}
